import { ReactNode } from 'react';
import styles from './TrackCard.module.scss';

export const Stat = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className={styles.stat}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

export const StatDivider = () => <div className={styles.statDivider} />;
